import { render, staticRenderFns } from "./WalletTopup.vue?vue&type=template&id=6b4cf670&"
import script from "./WalletTopup.vue?vue&type=script&lang=js&"
export * from "./WalletTopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports